<template>
  <div class="container-fluid">
    <audit-header :audit="audit"/>
    <div class="col-lg-12 col-md-12 col-sm-12">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">
            Accept An Audit
          </h4>
          <h6 class="card-subtitle">
            An organisation has asked you to carry out an audit. You may also assign auditors at this time.
          </h6>
        </div>
        <form @submit.prevent="handleSubmit" class="form-horizontal">
          <div class="form-group row">
            <label class="col-sm-3 text-right control-label col-form-label" for="auditors">Auditor</label>
            <div class="col-sm-6">
              <multiselect :class="{'is-invalid': submitted && errors.has('auditors')}" :clear-on-select="true"
                           :close-on-select="true" :disabled="!saveShow"
                           :hide-selected="false" :internal-search="false" :multiple="false" :options="auditorList"
                           :preselect-first="false" :preserve-search="true" :searchable="false" class="form-control"
                           id="auditors" label="email" name="auditors" placeholder="Select Auditor"
                           track-by="id" v-model="selectedAuditor">
                <template slot="singleLabel" slot-scope="props">
                  {{ props.option.name }}
                </template>
                <template slot="option" slot-scope="props">
                  <div class="option__desc">
                    <h5>
                      {{ props.option.name }}
                      <br><small class="form-text">{{ props.option.public_key | hex_format(10, '....') }}</small>
                    </h5>
                    <span style="font-style: italic">
                      {{ props.option.description }}
                    </span>
                  </div>
                </template>
                <template slot="afterList">
                  <div class="col-xs-12">
                    <router-link :to="{name: 'new-address-book-entry'}"
                                 class="btn btn-block btn-lg btn-outline-success">
                      <i class="fa fa-plus-circle"></i>&nbsp;Add Auditor
                    </router-link>
                  </div>
                </template>
              </multiselect>
              <div class="invalid-feedback" v-if="submitted && errors.has('auditors')">
                {{ errors.first('auditors') }}
              </div>
            </div>
          </div>
          <div class="form-group row">
            <label class="col-sm-3 text-right control-label col-form-label" for="comments">Comments</label>
            <div class="col-sm-6">
              <input class="form-control" id="comments" name="comments" placeholder="Comments" type="text"
                     v-model="comments">
            </div>
          </div>
          <div class="card-footer">
            <div class="form-group m-b-0 text-right">
              <div class="button-group">
                <button :disabled="submitted" class="btn waves-effect waves-light btn-success" type="submit">
                  Accept
                </button>
                <button @click="rejectAudit()" class="btn waves-effect waves-light btn-secondary" type="button">
                  Reject
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
    <proposal-stat :proposal_id="proposal_id" v-if="proposal_id"/>
  </div>
</template>

<script>

  import Multiselect from 'vue-multiselect';
  import {mapGetters} from 'vuex';
  import EventBus from '@/event-bus';
  import ProposalStat from '@/components/protected/common/ProposalStat.vue';
  import AuditHeader from '@/components/protected/common/AuditHeader.vue';
  import {apiMixin} from '@/utils/api-mixin';

  export default {
    name: 'AuditorAssignment',
    components: {ProposalStat, Multiselect, AuditHeader},
    mixins: [apiMixin('audit')],
    props: ['auditId'],
    data() {
      return {
        audit: null,
        current_user_role: null,
        status: null,
        auditorList: [],
        auditors: [],
        assignee: [],
        submitted: false,
        saveShow: true,
        optionSelected: {},
        selectedAuditor: null,
        tv_audit: null,
        comments: null,
        proposal_id: null
      };
    },
    computed: {
      ...mapGetters(['currentUser', 'activeGroup'])
    },
    beforeMount() {
      this.init();
    },
    methods: {
      async init() {
        EventBus.$emit('showBlockUI');
        await this.getProposal(this.auditId);
        await this.getAuditById(this.auditId);
        await this.getAuditors();
        EventBus.$emit('hideBlockUI');
      },
      async getProposal(auditId) {
        try {
          const ACCEPT_AUDIT = 'Accept Audit';
          const proposals = (await this.$api.get(`/groups/groups/${this.activeGroup.group_id}/proposals/by_references?description=${ACCEPT_AUDIT}&reference_1=${auditId}`)).data;
          console.log(proposals);
          if (proposals.length > 1) {
            console.error('More than one proposal is unexpected');
          }
          if (proposals.length > 0) {
            EventBus.$emit('hideBlockUI');
            await this.$router.push({name: 'view-proposal', params: {proposalId: proposals[0].proposal_id}});
          }
        } catch (e) {
          console.error(e);
        }
      },
      async getAuditById(auditId) {
        try {
          this.audit = (await this.$api.get(`/audits/${auditId}`)).data;
        } catch (e) {
          console.error(e);
        }
      },
      async acceptAudit() {
        // eslint-disable-next-line no-unused-vars
        let isProposal = false;
        if (this.activeGroup && this.activeGroup.threshold > 1) {
          isProposal = true;
        }
        await this.callApi('loader', isProposal, 'Audit accepted', async () => {
          await this.$api.patch(`/audits/${this.auditId}/accept`, {
            comments: this.comments
          });
          if (this.selectedAuditor) {
            await this.$api.patch(`/audits/${this.auditId}/auditors`, {
              field_auditors: this.selectedAuditor.public_key,
              comments: this.comments
            });
          }
        });
        this.$router.push({name: isProposal ? 'proposals' : 'viewaudit'});
      },
      async rejectAudit() {
        // eslint-disable-next-line no-unused-vars
        let isProposal = false;
        if (this.activeGroup && this.activeGroup.threshold > 1) {
          isProposal = true;
        }
        await this.callApi('loader', isProposal, 'Audit rejected', async () => {
          await this.$api.patch(`/audits/${this.auditId}/reject`, {
            comments: this.comments
          });
        })
        this.$router.push({name: isProposal ? 'proposals' : 'viewaudit'});
      },
      async getAuditors() {
        this.auditors = [];
        try {
          this.auditorList = (await this.$accounts.get('addressbook/user?address_type=Group')).data;
        } catch (e) {
          console.error(e);
        }
      },
      async handleSubmit() {
        this.submitted = true;
        try {
          const valid = await this.$validator.validate();
          if (valid) {
            await this.acceptAudit();
          }
        } catch (e) {
          this.$showError(e);
        }
      }

    }
  }
</script>

<style scoped>
</style>
